import axios from 'axios';

import {
  API_URL,
  HUB_API_URL,
  INVENTORY_API_URL,
  MSAL_CLIENT_ID,
  PROXY_API_BASE_URL,
} from '@/config/env';
import { conformanceRequest, hubRequest, inventoryRequest } from '@/config/msalConfig';
import { getToken } from './utils';

export const inventoryApi = axios.create({
  baseURL: INVENTORY_API_URL,
});

inventoryApi.interceptors.request.use(async function (config) {
  const token = await getToken(inventoryRequest);
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const conformanceApi = axios.create({
  baseURL: API_URL,
});

conformanceApi.interceptors.request.use(async function (config) {
  const token = await getToken(conformanceRequest);
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const hubApi = axios.create({
  baseURL: HUB_API_URL,
});

hubApi.interceptors.request.use(async function (config) {
  const token = await getToken(hubRequest);
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const proxyApi = axios.create({
  baseURL: PROXY_API_BASE_URL,
});

proxyApi.interceptors.request.use(async function (config) {
  // Do something before request is sent

  try {
    const token = await getToken({
      scopes: [`api://${MSAL_CLIENT_ID}/user_impersonation`],
    });
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  } catch (e) {
    console.error(e);
    return config;
  }
});
